import { SharingArrangementModelStateType } from '@g2-shared/api-client/generated/settlement-app';

export const SharingArrangementModelStateTypeLabelMapper: Record<
  SharingArrangementModelStateType,
  string
> = {
  [SharingArrangementModelStateType.CREATING]: 'Creating',
  [SharingArrangementModelStateType.PARAMETRIZING]: 'Parametrizing',
  [SharingArrangementModelStateType.FORMING]: 'Forming',
  [SharingArrangementModelStateType.PREPARED]: 'Prepared',
  [SharingArrangementModelStateType.REJECTED]: 'Rejected',
  [SharingArrangementModelStateType.VERIFIED]: 'Verified',
  [SharingArrangementModelStateType.CLOSED]: 'Closed',
  [SharingArrangementModelStateType.ACTIVATED]: 'Activated',
  [SharingArrangementModelStateType.DEACTIVATING]: 'Deactivating',
  [SharingArrangementModelStateType.DEACTIVATED]: 'Deactivated',
  [SharingArrangementModelStateType.DELETED]: 'Deleted',
};
